// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const EmptyStateViewLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-emptystateview" */ "./EmptyStateView")).then((bundle)=>{
        return {
            default: bundle.EmptyStateView
        };
    });
export const LazyEmptyStateView = /*#__PURE__*/ lazy(EmptyStateViewLazyLoader);
